<template>
  <button class="jbs-btn" :style="{backgroundColor: color}"> 
      <slot ></slot>
      <i class="icon" :class="[icon]"></i>
  </button>
</template>

<script>
export default {

 props: {
    icon: {
      type: String,
      default: 'Button'
    },
    color: {
      type: String,
    }
  },

}
</script>

<style scoped>

.jbs-btn{
    border-radius: 5px;
    padding: 10px 20px;
    height: 40px;
    margin: 10px;
    border: none;
    cursor: pointer;
    font-size: 15px;
}

button:focus {
    border: none;
    outline: none;
}

.icon{
    margin-left: 8px;
}
</style>